import Select from "./Select";
import { Controller, useFormContext } from "react-hook-form";

export default function SelectForm({ name, options = {}, canBeEmpty = false, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <Select
                    {...field}
                    options={options}
                    canBeEmpty={canBeEmpty}
                    error={error?.message}
                    {...other}
                />
            )}
        />
    );
}
